export default __webpack_public_path__ + "static/media/thumbnail-05.0d1499f3.png";